import { FC, useContext } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const Slide: FC<any> = ({
	slide,
	handleTouchStart,
	handleTouchEnd,
	handleTouchMove,
}) => {
	const { lang } = useContext(GlobalContext);

	return (
		<SlideWrapper className="slide-item">
			<Content>
				<LocalizedLink href={`/success-stories/story/${slide.url}`}>
					<ImageWrapper
						onTouchEnd={() => handleTouchEnd()}
						onTouchMove={(e) => handleTouchMove(e)}
						onTouchStart={(e) => handleTouchStart(e)}
					>
						<picture>
							<Image
								loading="lazy"
								src={getImage(slide?.preview)} // TODO: check the image
								alt={translate(lang, {
									en: `Viber Services to Promote Your Business ${slide.url}`,
									ru: `Сервисы Viber для продвижения вашего бизнеса ${slide.url}`,
									ua: `Сервіси Viber для просування вашого бізнесу ${slide.url}`,
								})}
							/>
						</picture>
					</ImageWrapper>

					<Paragraph>
						{parseHTML(slide?.story?.shortDescription)}

						<span>
							<Dots>...</Dots>
							<Button>READ STORY</Button>
						</span>
					</Paragraph>
				</LocalizedLink>
			</Content>
		</SlideWrapper>
	);
};

const SlideWrapper = styled.div`
	width: 50%;
	min-width: 50%;
	box-sizing: border-box;

	@media (max-width: 600px) {
		width: 100%;
		min-width: 100%;
	}
`;

const Content = styled.div`
	box-sizing: border-box;

	a {
		text-decoration: none;
	}

	a:hover {
		img {
			transform: scale(1.08);
		}
	}
`;

const ImageWrapper = styled.div`
	width: 100%;
	padding-top: 48%;
	position: relative;
	overflow: hidden;
	border-radius: 40px;
	margin-bottom: 25px;
	mask-image: radial-gradient(white, black);

	&:hover {
		img {
			transform: scale(1.08);
		}
	}

	@media (max-width: 400px) {
		border-radius: 30px;
	}
`;

const Image = styled.img`
	position: absolute;
	width: 100%;
	max-width: 100%;
	height: 100%;
	max-height: 100%;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	display: block;
	transition: 0.3s;
	object-fit: cover;

	@media (max-width: 600px) {
		margin-bottom: 12px;
	}

	@media (max-width: 400px) {
		margin-bottom: 12px;
	}
`;

const Paragraph = styled.div`
	font-family: var(--font-sans);

	font-size: 27px;
	line-height: 35px;
	color: var(--color-purple);
	margin-top: 33px;
	margin-left: 20px;
	padding-right: 35px;

	@media (max-width: 900px) {
		padding-right: 13px;
		font-size: 20px;
		line-height: 25px;
	}

	@media (max-width: 833px) {
		max-width: 230px;
		margin-left: auto;
		margin-right: auto;
		margin-top: 18px;
		font-family: var(--font-sans);

		font-size: 16px;
		line-height: 25px;
		color: var(--color-purple);
	}

	@media (max-width: 533px) {
		font-size: 15px;
		max-height: 50px;
		overflow: hidden;
		position: relative;
	}
`;

const Button = styled.span`
	position: absolute;
	display: block;
	width: 90px;
	bottom: 3px;
	right: 0;
	font-family: var(--font-sans);

	font-weight: var(--font-bold);
	font-size: 12px;
	line-height: 16px;
	text-transform: uppercase;
	color: var(--color-purple);
	border: 2px solid var(--color-purple);
	background-color: var(--color-white);
	border-radius: 12px;
	text-align: center;
	z-index: 100;
`;

const Dots = styled.span`
	position: absolute;
	right: 85px;
	bottom: -1px;
	padding-left: 3px;
	line-height: 13px;
	width: 30px;
	height: 20px;
	background-color: var(--color-white);
	text-align: left;
	color: var(--color-purple);
	z-index: 50;
`;

export default Slide;
